import { BackArrow, DocLinksIcon, SuccessArrowIcon } from "../../Icons/Icons"
import Dropdown from "../../Dropdown/Dropdown"
import React, { useEffect, useState } from 'react'
import { getDocument, getUploadedDocuments } from "../../../features/documents/documents"
import { showSnackBar } from "../../Snackbar/Snackbar"
import { useDispatch, useSelector } from "react-redux"
import { useMyContextLoading } from "../../LoadingContextProvider/LoadingContextProvider"
import EmailTemplate from "./EmailTemplate"
import { getTemplateReq, getTemplatesReq } from "../../../features/emails/emails"
import { selectFeatureFlag } from "../../../features/featureFlags/selectors"
import { DOCUMENTS_AUDIO_FLAG, isAudioKey } from "../../../constants/callRecordings"
import { REQUEST_ERRORS_FILES } from "../../../constants/requestErrorFlags"

const Compose = ({ setTab, userData, userId }) => {
  const dispatch = useDispatch()
  const audioEnabled = useSelector(selectFeatureFlag(DOCUMENTS_AUDIO_FLAG))
  const filesStrict = useSelector(selectFeatureFlag(REQUEST_ERRORS_FILES))
  const { triggerLoading } = useMyContextLoading()

  const [files, setFiles] = useState([])
  const [templates, setTemplates] = useState([])
  const [dropdownTemplates, setDropdownTemplates] = useState('')
  const [textAreaTemplate, setTextAreaTemplate] = useState('')
  const [subject, setSubject] = useState('')
  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFilesBase64, setSelectedFilesBase64] = useState([])
  const [loading, setLoading] = useState([])
  const getDocs = async () => {
    triggerLoading(true)
    const response = await dispatch(getUploadedDocuments({ offset: 0, limit: 1000, userId: userId }))
    if (response?.payload?.data?.docs && response?.payload?.data?.docs?.length > 0) {
      const docs = response.payload.data.docs
      setFiles(audioEnabled ? docs.filter((doc) => !isAudioKey(doc?.key)) : docs)
    } else {
      console.log('No payment data available.')
    }
    if (response.error) {
      showSnackBar("error", "Something went wrong!")
    } else if (response) {
    }
    triggerLoading(false)
  }

  const getTemplates = async () => {
    triggerLoading(true)
    const response = await dispatch(getTemplatesReq({ type: "email" }))
    if (response?.payload?.data && response?.payload?.data?.length > 0) {
      setTemplates(response?.payload?.data)
    } else {
      console.log('No payment data available.')
    }
    if (response.error) {
      showSnackBar("error", "Something went wrong!")
    } else if (response) {
    }
    triggerLoading(false)
  }

  const getTemplate = async ({ templateId }) => {
    triggerLoading(true)
    const response = await dispatch(getTemplateReq({ templateId, userId }))

    if (response?.payload?.data?.message && response?.payload?.data?.message?.length > 0) {
      setTextAreaTemplate(response?.payload?.data?.message)
      setSubject(response?.payload?.data?.subject)
    } else {
      console.log('No payment data available.')
    }
    if (response.error) {
      showSnackBar("error", "Something went wrong!")
    } else if (response) {
    }
    triggerLoading(false)
  }
  const getDocBase64 = async (key) => {
    setLoading((prevLoading) => [
      ...prevLoading,
      {
        key: key,
        status: true
      }
    ])

    try {
      const response = await dispatch(getDocument(key))

      if (filesStrict && (response?.error || typeof response?.payload?.data !== 'string')) {
        showSnackBar("error", typeof response?.payload === 'string' ? response.payload : 'Unable to attach the document')
        setSelectedFiles((prevFiles) => prevFiles.filter((selected) => selected.key !== key))
        return
      }

      setSelectedFilesBase64((prevFiles) => [
        ...prevFiles,
        {
          key: key,
          url: key,
          file: response?.payload?.data
        }
      ])
    } catch (error) {
      console.error("Error getting document:", error)
    } finally {
      setLoading((prevLoading) => prevLoading.filter((loadingFile) => loadingFile.key !== key))
    }
  }

  useEffect(() => {
    const fetch = async () => {
      await getDocs()
      await getTemplates()
    }
    fetch()
  }, [])

  const handleDropdown = async (e) => {
    setDropdownTemplates(e)
    await getTemplate({ templateId: e })
  }

  return (
    <div className="flex justify-between gap-6 mb-6">
      <div className="w-full  flex flex-col gap-8">
        <div className="flex items-center justify-start gap-2 cursor-pointer" onClick={() => setTab("allEmail")}>
          <div className="h-6 w-6 flex items-center justify-center">
            <BackArrow />
          </div>
          <h5 className="font-bold text-xl-20">Compose</h5>
        </div>
        <Dropdown menuItems={templates} setValue={(e) => handleDropdown(e)}
          value={dropdownTemplates} variant="standard" label="Email Template" />
        <EmailTemplate selectedFiles={selectedFiles} selectedFilesBase64={selectedFilesBase64} loading={loading}
          setSelectedFiles={setSelectedFiles} setSelectedFilesBase64={setSelectedFilesBase64}
          userData={userData} setTab={setTab} textAreaTemplate={textAreaTemplate} subjectTemp={subject} filesStrict={filesStrict} />
      </div>
      <div
        className="flex flex-col gap-6 px-6 py-5 rounded-2xl shadow-lg border border-divider w-full max-w-[500px] min-w-[350px]">
        <h6 className="font-bold">Document Links</h6>
        <div className="flex  flex-col gap-1">
          {files.map((file) => {
            const createdAtDate = new Date(file.createdAt)
            const isSelected = selectedFiles.includes(file)

            const handleFileClick = async () => {
              if (isSelected) {
                setSelectedFiles((prevSelectedFiles) => prevSelectedFiles.filter((selectedFile) => selectedFile !== file))
                setSelectedFilesBase64((prevSelectedFiles) => prevSelectedFiles.filter((selectedFile) => selectedFile.key !== file.key))
              } else {
                setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, file])
                await getDocBase64(file?.key)
              }
            }
            return (
              <div
                key={file.key}
                className={`flex justify-start items-center rounded-lg p-2 gap-2 w-full text-[14px] text-text-secondary cursor-pointer select-none ${isSelected ? 'bg-primary-main/10' : ''}`}
                onClick={() => handleFileClick(file)}
              >
                <div className="w-6 h-6 flex justify-center items-center">
                  <DocLinksIcon />
                </div>
                <span className="w-full truncate">
                  {createdAtDate.getMonth() + 1}-{createdAtDate.getDate()}-{createdAtDate.getFullYear()} - {file?.name}
                </span>
                {isSelected && <div className="flex items-center justify-center w-6 h-6"><SuccessArrowIcon /></div>}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Compose
